import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

declare global {
  interface Window {
    Pusher: any;
  }
}

export default defineNuxtPlugin(nuxtApp => {
  window.Pusher = Pusher;

  const { user } = useUserStore();

  const echo = new Echo({
    broadcaster: 'reverb',
    key: 'trgmj2csb3gecmwgsxcs',
    forceTLS: true,
    wsHost: 'ws.development.backend.medmastery.io',
    wsPort: 433,
    disableStats: true,
    enabledTransports: ['ws', 'wss'],
    authEndpoint: '/api/broadcasting/auth',
  });

  const connectToChannel = () => {
    echo.connect();

    echo.join('medmastery')
      .here((users: any[]) => console.log(users))
      .joining((user: any) => console.log('joining', user))
      .listen('TestEvent', (event: any) => {
        console.log(event);
      });
  };

  watch(user, async u => {
    if (!u) {
      return;
    }

    connectToChannel();
  }, { immediate: true });

  return {
    provide: {
      echo,
    },
  };

});